import { ScheduleType } from "@pulse/pulse-rpcs/lib/email-cycle/scheduleType";
import { Instance, SnapshotIn, types } from "mobx-state-tree";
import {
  createDatePickerModel,
  DatePickerModel,
} from "../../models/DatePickerModel";
import { createTimeOfDayModel, TimeOfDayModel } from "./TimeOfDayModel";

export const SingleTimeScheduleModel = types
  .model("SingleTimeScheduleModel", {
    type: types.literal("SINGLE_TIME_SCHEDULE"),
    date: DatePickerModel,
    time: TimeOfDayModel,
  })
  .views((store) => ({
    get isEmptyValues(): boolean {
      return !store.date.date;
    },

    get hasValidateError(): boolean {
      return !!store.date.validationError;
    },

    get rpcObject(): ScheduleType.SingleTime {
      return new ScheduleType.SingleTime(
        store.date.rpcObject,
        store.time.rpcObject,
      );
    },
  }));

export const createSingleTimeScheduleModel = (
  singleTimeSchedule?: SnapshotIn<typeof SingleTimeScheduleModel>,
): Instance<typeof SingleTimeScheduleModel> =>
  SingleTimeScheduleModel.create(
    singleTimeSchedule ?? {
      type: "SINGLE_TIME_SCHEDULE",
      date: createDatePickerModel(),
      time: createTimeOfDayModel(),
    },
  );
